import { call, all } from "redux-saga/effects";
import { LoginActionWatcher } from "../containers/LoginContainer/saga";
import { dashboardActionWatcher } from "../containers/DashboardContainer/saga";
import { residentsActionWatcher } from "../containers/ResidentsContainer/saga";

import { AlertsBActionWatcher } from "../containers/Alert_BContainer/saga";

import { forgotPasswordActionWatcher } from "../containers/ForgotPassword/saga";
import { SupportActionWatcher } from "../containers/SupportCondainer/saga";
import { PurchaseActionWatcher } from "../containers/PurchaseContainer/saga";
import { onboardingtwoActionWatcher } from "../containers/Onboarding2Container/saga";
import { myProfileActionWatcher } from "../containers/MyprofileContainer/saga";
import { SettingsActionWatcher } from "../containers/SettingsContainer/saga";
import { apartmentActionWatcher } from "../containers/ApartmentContainer/saga";
import { rwaMemberActionWatcher } from "../containers/RwaContainer/saga";
import { onboardingResActionWatcher } from "../containers/Onboarding_residentsContainer/saga";
import { invoiceActionWatcher } from "../containers/InvoiceContainer/saga";
import { ApprovedResidentsActionWatcher } from "../containers/ApprovedResidentsContainer/saga";
import { resetPasswordActionWatcher } from "../containers/ResetPasswordContainer/saga";

function* rootSaga() {
  yield all([
    call(LoginActionWatcher),
    call(dashboardActionWatcher),
    call(residentsActionWatcher),

    call(AlertsBActionWatcher),
    call(PurchaseActionWatcher),

    call(forgotPasswordActionWatcher),
    call(SupportActionWatcher),
    call(onboardingtwoActionWatcher),
    call(myProfileActionWatcher),
    call(SettingsActionWatcher),
    call(rwaMemberActionWatcher),
    call(apartmentActionWatcher),
    call(onboardingResActionWatcher),
    call(invoiceActionWatcher),
    call(ApprovedResidentsActionWatcher),
    call(resetPasswordActionWatcher),
  ]);
}

export default rootSaga;
